import React from "react"
import Paper from "material-ui/Paper"
import strings from "../../../localization/strings"
import IconButton from "material-ui/IconButton"
import FontIcon from "material-ui/FontIcon"
import { CircularProgress } from "material-ui"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import { IPayrollExpenses, IPayrollExpensesHierarchy, IPayrollExpensesHierarchyEmployee } from "../../../models"
import { hasPermission } from "../../../helpers/permissionHelper"
import PayrollPriorPeriodExpensesByHierarchyTable from "./PayrollPriorPeriodExpensesByHierarchyTable"

interface IProps {
    payrollExpensesData: IPayrollExpenses
    loading: boolean
    selectedHierarchies: IPayrollExpensesHierarchy[]
    onDownload(): void
    onEmployeeLock(): void
    onEmployeeUnLock(): void
    onLock(): void
    onUnLock(): void
    onClose(): void
    onExport(): void
    handleSelectHierarchy(selectedHierarchies: IPayrollExpensesHierarchy[]): void
    handleSelectEmployee(selectedEmployees: IPayrollExpensesHierarchyEmployee[], unselectedEmployees: IPayrollExpensesHierarchyEmployee[]): void
    onExpensePayrollFileDownload(expenseId: string): void
}

export default class PayrollExpensesPriorPeriodByHierarchy extends React.Component<IProps, any> {
    private PayrollPriorPeriodExpensesByHierarchyTable = null
    render() {
        const payrollExpensesHierarchies = this.props.payrollExpensesData && this.props.payrollExpensesData.PayrollExpensesHierarchies
        let lockPayrollExpensePermission = hasPermission(AuthenticationStore.Permissions.Expense.LockPayrollExpense)
        let closePayrollExpensePermission = hasPermission(AuthenticationStore.Permissions.Expense.ClosePayrollExpense)
        if (!AuthenticationStore.checkSupervisorAllowPayrollActions()) {
            lockPayrollExpensePermission = false
            closePayrollExpensePermission = false
        }
        const renderElem =
            <div>
                {!this.props.loading && payrollExpensesHierarchies &&
                    payrollExpensesHierarchies.length > 0 &&
                    <div style={{ position: "absolute", right: 40, marginTop: -25 }}>
                        <IconButton data-intercom-target={"menu-Payroll-Btn-DownloadPayrollFile"} tooltip={strings.Download_Payroll_Expenses_File} onTouchTap={this.props.onDownload}>
                            <FontIcon className="fa fa-download" style={{ fontSize: 20 }} />
                        </IconButton>
                        {hasPermission(AuthenticationStore.Permissions.Expense.ExportPayrollExpense) &&
                            <IconButton data-intercom-target={"menu-Payroll-Btn-ExportPayrollExpense"} tooltip={strings.ExportPayrollFile} onTouchTap={this.props.onExport}>
                                <FontIcon className="fa fa-arrow-circle-right" style={{ fontSize: 20 }} />
                            </IconButton>
                        }
                    </div>
                }
                {this.props.loading ?
                    <div style={{ textAlign: "center", marginTop: 30 }}>
                        <CircularProgress />
                    </div> :
                    <div style={{ textAlign: "center", marginTop: 20 }}>
                        {payrollExpensesHierarchies && payrollExpensesHierarchies.length > 0 ?
                            <PayrollPriorPeriodExpensesByHierarchyTable
                                ref={(elem) => this.PayrollPriorPeriodExpensesByHierarchyTable = elem}
                                payrollExpensesHierarchies={payrollExpensesHierarchies}
                                handleSelectHierarchy={this.props.handleSelectHierarchy}
                                handleSelectEmployee={this.props.handleSelectEmployee}
                                onExpensePayrollFileDownload={this.props.onExpensePayrollFileDownload}
                            /> :
                            <div style={{ fontSize: 20, marginTop: 50 }}>{strings.No_Payroll_Expenses_by_Hierarchy_Data}</div>
                        }
                    </div>
                }
            </div>

        return hasPermission(AuthenticationStore.Permissions.Payroll.ViewPayroll) ?
            <Paper zDepth={1} style={{ marginTop: 15, paddingTop: 10, paddingBottom: 20, paddingLeft: 10, paddingRight: 10, position: "relative" }}>
                <div style={{ fontSize: 16, fontWeight: 600, position: "absolute", top: 15 }}>Prior Period Adjustments</div>
                {renderElem}
            </Paper> :
            renderElem
    }
}
